import { Component, Inject, LOCALE_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AbstractBiditComponent } from '../shared/controls/abstract.bidit.component';
import { MonthType } from '../shared/models/month.type.interface';
import { ReportExportDialog } from './report-export-dialog/report.export.dialog';

export interface FormatParameterData {
  format: string;
  extension: string;
  locale: string;
}

@Component({ template: '' })
export class AbstractReportComponent extends AbstractBiditComponent {

  years: number[] = new Array();
  months: MonthType[] = new Array();

  constructor(@Inject(LOCALE_ID) protected locale: string,
    protected dialog: MatDialog, deviceDetectorService: DeviceDetectorService) {
    super(deviceDetectorService);
  }

  protected getReportFormat(): Observable<FormatParameterData> {
    const dialogRef = this.dialog.open(ReportExportDialog, {
      width: '550px',
      data: {
      }
    });

    return dialogRef.afterClosed().pipe(
      map((data: FormatParameterData) => { return data })
     );
  }

  setupDates() {
    let today = new Date();

    for (let i = today.getFullYear(); i >= 2019; i--) {
      this.years.push(i);
    }
    for (let i = 0; i <= 11; i++) {
      today.setMonth(i);

      this.months.push({
        MonthNum: i,
        MonthName: today.toLocaleString(this.locale, { month: 'short' })
      } as MonthType);
    }
  }
}
